import { Icon, Text } from 'shared/components/ui';

import styles from './index.module.scss';

interface Props {
	onClick: any;
}

export const BackToTop = ({ onClick }: Props) => {
	return (
		<div className={styles.wrapper} onClick={onClick}>
			<Text variant="inter/15/semi" color="blue_new">
				Back to top
			</Text>
			<Icon icon="chevron" size={20} className={styles.icon} />
		</div>
	);
};
